/**
 * Created by portiz on 8/24/2018.
 */
class Settings {

    /**
     * The url where the windows app is
     */
    static getDownloadWindowsAppURL(){
        return 'https://google.com';
    }

    /**
     * The url where the mac app is
     */
    static getDownloadMacAppURL(){
        return 'https://google.com';
    }

    /**
     * THe url where the android app is
     */
    static getDownloadAndroidAppURL(){
        return 'https://google.com';
    }

    /**
     * The url where the ipad app is
     */
    static getDownloadIpadsAppUrl(){
        return 'https://google.com';
    }

    static getStripeToken(){
        return 'pk_test_nAq1KhiYjAcXNpTO8cDB0jmW';
    }

    static getItemsSubscribedUsersAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ItemsMainAccount';
    }

    static getPlanDetailsAPI(){
        return 'https://www.genialskillsservice.com:8385/api/PlanDetailsRead';
    }

    static getPlansAvailableAPI(){
        return 'https://www.genialskillsservice.com:8385/api/PlansRead';
    }

    static getPlanCostAPI(){
        return 'https://www.genialskillsservice.com:8385/api/PlanCalculateCosts';
    }

    static getSubscribeUserToPlanAPI(){
        return 'https://www.genialskillsservice.com:8385/api/SubscribeUserToPlan';
    }

    static getAssignSeatAPI(){
        return 'https://www.genialskillsservice.com:8385/api/AssignSeat';
    }

    static getUserNewPasswordInsertAPI(){
        return 'https://www.genialskillsservice.com:8385/api/PasswordUpdateByUser';
    }

    static getUserMainAddressAPI(){
        return 'https://www.genialskillsservice.com:8385/api/MainAccountAddressRead';
    }

    static getUserMainAddressUpdateAPI(){
        return 'https://www.genialskillsservice.com:8385/api/MainAccountAddressUpdate';
    }

    static getRegisterProfileAPI(){
        return 'https://www.genialskillsservice.com:8385/api/RegisterProfile';
    }

    static getRegisterMainAccountAPI(){
        return 'https://www.genialskillsservice.com:8385/api/Register';
    }
    static getProductLessonsAPI(){
        return 'https://www.genialskillsservice.com:8385/api/LessonsRead';
    }

    static getSyllabusReadAPI(){
        return 'https://www.genialskillsservice.com:8385/api/SyllabusRead';
    }

    static getUserQuizDetailsAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfileQuizResultDetailsRead';
    }

    static getLessonExamsAPI(){
        return 'http://74.208.103.1:8882/api/LessonExamsRead';
    }

    static getUserQuizzesTriesAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfileQuizTriesRead';
    }

    static getProfileUpdatePasswordAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfilePasswordReset';
    }

    static getProfileUpdateInformationAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfileUpdateInformation';
    }

    static getProfileInformationReadAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfileInformationRead';
    }

    static getProfilesAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfilesRead';
    }

    static getProfileProductsAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfileItemsRead';
    }

    static getUserSubscriptionsAPI(){
        return 'https://www.genialskillsservice.com:8385/api/SubscriptionsClientRead';
    }

    static getStudentAverageAPI(){
        return 'https://www.genialskillsservice.com:8385/api/ProfileAverageByLessons';
    }

    static getStudentLessonAverageApi(){
        return 'https://www.genialskillsservice.com:8385/api/ProfileLessonAverageByLessonIdRead';
    }

     static getUsernameAvailabilityAPI(){
         return 'https://www.genialskillsservice.com:8385/api/UsernameCheckAvailability';
     }

     static getEmailAvailabilityAPI(){
         return 'https://www.genialskillsservice.com:8385/api/EmailCheckAvailability';
     }

     static getLoginAPI(){
         return 'https://www.genialskillsservice.com:8385/api/LoginMainAccount';
     }

     static getCountriesAPI(){
         return 'https://www.genialskillsservice.com:8385/api/CountryReadAvailable';
     }

     static getStateProvincesAPI(){
         return 'https://www.genialskillsservice.com:8385/api/StatesProvidencesRead';
     }
}

export default Settings;


// WEBPACK FOOTER //
// ./src/custom-classes/settings.js